import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards';
import { AuthLayoutComponent, ErrorLayoutComponent, MainLayoutComponent } from '@core/layout';

export const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: '',
                loadChildren: () =>
                    import('./modules/dashboard/dashboard.routes').then(
                        (m) => m.routes
                    ),
            },
            {
                path: 'applications',
                loadChildren: () =>
                    import('./modules/applications/applications.routes').then(
                        (m) => m.routes
                    ),
            },
            {
                path: 'users',
                loadChildren: () =>
                    import('./modules/users/users.routes').then(
                        (m) => m.routes
                    ),
            },
            {
                path: 'api-keys',
                loadChildren: () =>
                    import('./modules/api-keys/api-keys.routes').then(
                        (m) => m.routes
                    ),
            },
            {
                path: 'contact-messages',
                loadChildren: () =>
                    import('./modules/contact-messages/contact-messages.routes').then(
                        (m) => m.routes
                    ),
            },
            {
                path: 'comments',
                loadChildren: () =>
                    import('./modules/comments/comments.routes').then(
                        (m) => m.routes
                    ),
            },
        ],
    },
    {
        path: 'auth',
        component: AuthLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('./modules/auth/auth.routes').then(
                        (m) => m.routes
                    ),
            },
        ],
    },
    {
        path: 'error',
        component: ErrorLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('./modules/errors/errors.routes').then(
                        (m) => m.routes
                    ),
            },
        ],
    },
    { path: '**', redirectTo: 'error/not-found' }
];
